export class AuthInfo {

  constructor(public $uid: string) {
  }

  isLoggedIn(): boolean {
    return !!this.$uid;
  }

}
